import { DraggableElement } from "../ViewModel/DraggableElement";
import { FtlRoutingViewModel } from "../ViewModel/FtlRoutingViewModel";

export function createRoutingInfoForPlantDockRouting(element: DraggableElement, dock: FtlRoutingViewModel) {
  const info: FtlRoutingViewModel = { ...element.RoutingInfo };
  info.Day = dock.Day;
  info.Km = dock.Km;
  info.DrivingHours = dock.DrivingHours;
  info.Dock = dock.Dock;
  info.DockCode = dock.DockCode;
  info.LocationName = dock.LocationName;
  info.RoutingType = dock.RoutingType;
  info.PuDoType = dock.PuDoType;
  info.ETA = dock.ETA;
  info.ETD = dock.ETD;
  info.ClientId = dock.ClientId;
  return info;
}
